import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { NotaDebito } from '../../../models/nota-debito';
import { NotaDebitoDetalle } from '../../../models/nota-debito-detalle';
import { ComprobanteService } from '../../../services/comprobante.service';
import { Caja } from '../../../models/caja';
import{ CajaService } from '../../../services/caja.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { VentaListModalComponent } from '../../../components/modals/venta-list-modal/venta-list-modal.component';
import { Venta } from '../../../models/venta';
import * as moment from 'moment';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { Validation } from '../../../config/validation';
import { NotaDebitoService } from '../../../services/nota-debito.service';
import { TarifaIvaService } from '../../../services/tarifa-iva.service';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { Transferencia } from '../../../models/transferencia';
import { UtilsService } from '../../../services/utils.service';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';

@Component({
  selector: 'app-nota-debito-add',
  templateUrl: './nota-debito-add.component.html',
  styleUrls: ['./nota-debito-add.component.css'],
	providers: [
        ComprobanteService,
        CajaService,
        ParametroService,
        NotaDebitoService,
        TarifaIvaService,UtilsService,
        ImpuestoPorcentajeService
    ]
})
export class NotaDebitoAddComponent implements OnInit {
  public nota_debito: NotaDebito;
	public notaDebitoDetalle: Array<NotaDebitoDetalle>;
	public nota_detalle: NotaDebitoDetalle;
	public caja: Caja;
	public cajas: Array<Caja>;
	public msgSweet: SweetMessage;
	public loading = false;
	public Mod_FactElec: string;
	public fecha_emision;
	public bsModalRef: BsModalRef;
	public venta: Venta;
	public IVA: number;
	public IVA_PARAM: number;
	public vl: Validation;
	public detalle: String;
	public total_pago: number;
	public cambio: number;
	public is_numero_manual: boolean;
    public numero_documento: String;
    public tarifa_iva: Array<any>;
    public cobro: Cobro;
    public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public valorefectivo: number;
    public fecha_actual;
    public fecha_MesAnt;
    public correos: Array<any>;
    public parametros: Array<any>
    public iva_id : number;
    public iva_vigente:boolean;
    public iva_porcentaje : any;
    public transferencias: Array<Transferencia>;
    public is_venta:boolean;
    public calculo_decimales: number;
    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;


	constructor(
		public comprobanteService: ComprobanteService,
		private ss: SessionService,
		public cajaService: CajaService,
		private modalService: BsModalService,
		private parametroService: ParametroService,
        private notaDebitoService: NotaDebitoService,
        private tarifaIvaService: TarifaIvaService,
        public impuestoPorcentajeService: ImpuestoPorcentajeService,
        public utils: UtilsService,

	) {
		this.caja = new Caja();
        this.cajas = [];
        this.correos = [];
		this.msgSweet = new SweetMessage();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.nota_debito = new NotaDebito();
		this.notaDebitoDetalle = [];
        this.fecha_emision = moment(this.fecha_emision);
        this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.venta = new Venta();
		this.IVA = 0;
		this.IVA_PARAM = 0;
		this.vl = new Validation();
		this.detalle = "";
		this.nota_detalle = new NotaDebitoDetalle();
		this.total_pago = 0;
		this.cambio = 0;
		this.is_numero_manual = false;
        this.numero_documento = "";
        this.tarifa_iva = [];
        this.cobro = new Cobro();
        this.cheques = [];
        this.tarjetas = [];
        this.valorefectivo = 0;
        this.parametros = [];
        this.iva_id = 0;
        this.iva_vigente = false;
        this.iva_porcentaje = 0;
        this.transferencias = [];
        this.is_venta = false;
        this.calculo_decimales = 2;

	}

    ngOnInit() {
		let p1 = this.getCajas();
        let p2 = this.getParametros();
        let p3 = this.getTarifaIVA();
        let p4 = this.getParamDocumentoManual();
        let p5 = this.getIVA(129);
        this.loading = true;
        this.is_venta = true;

		Promise.all([p1,p2,p3, p4,p5]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

    getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
                    this.IVA = parseFloat(this.iva_porcentaje) / 100;
                    this.IVA_PARAM = this.iva_porcentaje;
                    this.calcularTotales();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
                    this.IVA = 0;
                    this.IVA_PARAM = 0;
					reject(err);
				}
			);

			
		});
	}

    getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getCajas(){
		return new Promise((resolve, reject) => {
			this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
				res => {
					this.cajas = res.data;
					resolve();
				},
				err => {
					this.cajas = [];
					reject(err);
				}
			);
		});
	}

    getParamDocumentoManual(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let documento_manual_id = 9;
            this.parametroService.getById(documento_manual_id).subscribe(
                res => {
                    this.is_numero_manual = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_numero_manual = false;
                    reject(err);
                }
            );
        });
    }

	onChangeCaja(){
        this.caja = this.cajas.filter(x => x.id = this.caja.id)[0];

        if( !this.caja ){
            this.caja = new Caja();
		}

		this.getNumeroComprobante();
	}
	
	getNumeroComprobante(){
		if( !this.caja.id ){
        this.msgSweet.showMessage('error-message', "Seleccione la caja");
        return;
		}
		
		this.loading = true;

		if(this.Mod_FactElec){
			this.nota_debito.tipo_comprobante_id = 11;
		}
		else{
			this.nota_debito.tipo_comprobante_id = 10;
		}
        this.comprobanteService.getSecuencial(this.nota_debito.tipo_comprobante_id, this.caja.id).subscribe(
        res => {
            this.loading = false;
            if(res.secuencial){
                this.nota_debito.serie = this.caja.sucursal.establecimiento;
                this.nota_debito.punto_emision = this.caja.punto_emision;
                this.nota_debito.secuencial = res.secuencial;
                this.nota_debito.numero_documento = this.nota_debito.serie + "-" + this.nota_debito.punto_emision + "-" + this.nota_debito.secuencial;
            }else{
                this.nota_debito.serie = "";
                this.nota_debito.punto_emision = "";
                this.nota_debito.secuencial = "";
                this.nota_debito.numero_documento = "";
            }
        },
        err => {
            this.loading = false;
            this.nota_debito.serie = "";
            this.nota_debito.punto_emision = "";
            this.nota_debito.secuencial = "";
            this.nota_debito.numero_documento = "";
            this.msgSweet.showMessage('error-message', err);
        }
    );
    }
    
    getTarifaIVA(){
		return new Promise((resolve, reject) => {
			this.tarifaIvaService.getAll("?impuesto_id=2").subscribe(
				res => {
					this.tarifa_iva = res.data;
					resolve();
				}, err => {
					this.tarifa_iva = [];
					reject();
				}
			);
		});
	}

    onSearch(id){
            let qs = "";//"&embed=retencion";
            const initialState = { qs };
            this.bsModalRef = this.modalService.show(VentaListModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

            this.bsModalRef.content.onSelectedRow.take(1).subscribe(venta => {
                /*if( compra.retencion ){
                    this.msgSweet.showMessage('error-message','La factura seleccionada ya tiene una retención');
                }else{
                    this.compra = compra;
                }*/
                this.venta = venta;
                this.correos = this.venta.cliente.correo.split(',');
                this.notaDebitoDetalle = [];
                this.calcularTotales();
            });
    }
    
    getSubtotal(venta){
            return parseFloat(venta.subtotal_iva12) + parseFloat(venta.subtotal_iva0);
    }
    
    verificationValue(event, notaCreditoDetalle: NotaDebitoDetalle, campo: string){
        if( event.target.value.trim().length === 0 ){
            if( campo === 'cantidad' ){
                notaCreditoDetalle[campo] = 1;
            }else{
                notaCreditoDetalle[campo] = 0;
            }
        }
    }

    changeValue(event, notaCreditoDetalle: NotaDebitoDetalle, campo: string){
        notaCreditoDetalle[campo] = event.target.value;
        notaCreditoDetalle.subtotal = notaCreditoDetalle.valor;

        this.calcularTotales();
    }

    onDelete(i) {
        this.notaDebitoDetalle.splice(i, 1);
        this.calcularTotales();
    }

    openModalDetalle(template: TemplateRef<any>, nota_detalle) {
        this.detalle = nota_detalle.detalle;
        this.nota_detalle = nota_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

    saveDetalle(){
        this.nota_detalle.detalle = this.detalle.toString().trim();
        this.detalle  = "";
        this.bsModalRef.hide();
    }

    calcularTotales() {
        this.nota_debito.subtotal_iva12 = 0;
        this.nota_debito.subtotal_iva0 = 0;
        this.nota_debito.iva = 0;
        this.nota_debito.total = 0;
        let cod_iva = 0;

        this.notaDebitoDetalle.forEach(obj => {
            cod_iva = obj.cod_iva;

            obj.subtotal = parseFloat(obj.valor.toString());
            if(obj.cod_iva == 0){
                this.nota_debito.subtotal_iva0 += parseFloat(obj.subtotal.toString());
                obj.iva = 0;
                obj.porct_iva = 0;
            }
            else{
                this.nota_debito.subtotal_iva12 += parseFloat(obj.subtotal.toString());
                obj.iva = obj.subtotal * this.IVA;
                obj.porct_iva = this.IVA_PARAM;
            }
        });

        if(cod_iva == 2){
            this.nota_debito.iva = Math.round((this.nota_debito.subtotal_iva12 * this.IVA) * 100) / 100;
        }
        else{
            this.nota_debito.iva = Math.round(this.nota_debito.subtotal_iva12 * 100) / 100;
        }

        this.nota_debito.subtotal = parseFloat(this.nota_debito.subtotal_iva0.toString()) + parseFloat(this.nota_debito.subtotal_iva12.toString());
        this.nota_debito.total = parseFloat(this.nota_debito.subtotal.toString()) + parseFloat(this.nota_debito.iva.toString());
        
        //Recalcular cambio
        this.total_pago = 0;
        this.cambio = (this.total_pago > this.nota_debito.total?(this.total_pago - this.nota_debito.total):0);
        this.cambio = Math.round(this.cambio * 100) / 100;
    }

    setNDElectronica(){
        let NdElectronica = {};
        NdElectronica['datos'] = {};
        NdElectronica['datos']['infoTributaria'] = {};
        NdElectronica['datos']['infoTributaria']['ambiente'] = "";
        NdElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        NdElectronica['datos']['infoTributaria']['razonSocial'] = "";
        NdElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        NdElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        NdElectronica['datos']['infoTributaria']['codDoc'] = "05"; //Nota de débito
        NdElectronica['datos']['infoTributaria']['estab'] = this.nota_debito.serie;
        NdElectronica['datos']['infoTributaria']['ptoEmi'] = this.nota_debito.punto_emision;
        NdElectronica['datos']['infoTributaria']['secuencial'] = this.nota_debito.secuencial.toString().padStart(9,"0");
        NdElectronica['datos']['infoTributaria']['dirMatriz'] = "";

        NdElectronica['datos']['infoNotaDebito'] = {};
        NdElectronica['datos']['infoNotaDebito']['fechaEmision'] =  moment(this.nota_debito.fecha_emision).format("DD/MM/YYYY");
        NdElectronica['datos']['infoNotaDebito']['dirEstablecimiento'] = "";
        NdElectronica['datos']['infoNotaDebito']['tipoIdentificacionComprador'] = this.venta.cliente.tipoidentificacion.cod_dni;
        NdElectronica['datos']['infoNotaDebito']['razonSocialComprador'] = this.venta.cliente.razon_social;
        NdElectronica['datos']['infoNotaDebito']['identificacionComprador'] = this.venta.cliente.dni;
        if(this.venta.cliente.es_contribuyente){
            NdElectronica['datos']['infoNotaDebito']['contribuyenteEspecial'] =  this.venta.cliente.num_contribuyente;
        }
        NdElectronica['datos']['infoNotaDebito']['obligadoContabilidad'] =  (this.venta.cliente.es_obligado == true ? "SI":"NO");
        NdElectronica['datos']['infoNotaDebito']['codDocModificado'] = "01"; //FACTURA
        NdElectronica['datos']['infoNotaDebito']['numDocModificado'] = this.venta.serie + "-"+this.venta.punto_emision + "-"+this.venta.secuencial.toString().padStart(9,"0");
        NdElectronica['datos']['infoNotaDebito']['fechaEmisionDocSustento'] = moment(this.venta.fecha_emision).format("DD/MM/YYYY");
        NdElectronica['datos']['infoNotaDebito']['totalSinImpuestos'] = (this.nota_debito.subtotal_iva12 + this.nota_debito.subtotal_iva0);

        NdElectronica['datos']['infoNotaDebito']['impuestos'] = [];
        if(this.nota_debito.subtotal_iva0 > 0){
            let impuestos = {};
            impuestos['codigo'] = 2;
            impuestos['codigoPorcentaje'] = 0;
            impuestos['tarifa'] = "0.00";
            impuestos['baseImponible'] = this.nota_debito.subtotal_iva0;
            impuestos['valor'] = "0.00";

            NdElectronica['datos']['infoNotaDebito']['impuestos'].push(impuestos);
        }

        if(this.nota_debito.subtotal_iva12 > 0){
            let impuestos = {};
            impuestos['codigo'] = 2;
            impuestos['codigoPorcentaje'] = 2;
            impuestos['tarifa'] = "12.00";
            impuestos['baseImponible'] = this.nota_debito.subtotal_iva12;
            impuestos['valor'] = this.nota_debito.iva;

            NdElectronica['datos']['infoNotaDebito']['impuestos'].push(impuestos);
        }

        NdElectronica['datos']['infoNotaDebito']['valorTotal'] = this.nota_debito.total;

        NdElectronica['datos']['infoNotaDebito']['pagos'] = [];
        if( this.nota_debito.tipo_pago == "CO" ){
            //01 => EFECTIVO
            if( this.valorefectivo > 0 ){
                let pago = {};
                pago["formaPago"] = "01";
                pago["total"] = parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString());
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                NdElectronica['datos']['infoNotaDebito']['pagos'].push(pago);
            }

            let totalChOtrosCon = 0;
            this.cheques.forEach(ch => {
                totalChOtrosCon += parseFloat(ch.valor.toString());
            });

            //20 => OTROS
            if( totalChOtrosCon > 0 ){
                let pago = {};
                pago["formaPago"] = "20";
                pago["total"] = totalChOtrosCon;
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                NdElectronica['datos']['infoNotaDebito']['pagos'].push(pago);
            }

            //16 => DEBITO; 19 => CREDITO
            this.tarjetas.forEach(tr => {
                let pago = {};
                pago["formaPago"] = (tr.debito_credito==="D"?"16":"19");
                pago["total"] = tr.valor;
                pago["plazo"] = tr.plazo;
                pago["unidadTiempo"] = tr.tiempo.toUpperCase();
                NdElectronica['datos']['infoNotaDebito']['pagos'].push(pago);
            });
        }else{
            //20 => OTROS
            let pago = {};
            pago["formaPago"] = "20";
            pago["total"] = parseFloat(this.nota_debito.total.toString()) - parseFloat(this.cambio.toString());
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            NdElectronica['datos']['infoNotaDebito']['pagos'].push(pago);
        }

        let totalTrOtrosCon = 0;
        this.transferencias.forEach(tr => {
            totalTrOtrosCon += parseFloat(tr.valor.toString());
        });

        if( totalTrOtrosCon > 0 ){
            let pago = {};
            pago["formaPago"] = "20";
            //pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
            pago["total"] = this.utils.redondear(totalTrOtrosCon, this.calculo_decimales);
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            NdElectronica['datos']['infoNotaDebito']['pagos'].push(pago);
        }

        NdElectronica['datos']['motivos'] = [];
        this.nota_debito.detalle.forEach((item) => {
            let motivo  = {};
            motivo['razon'] = item.razon;
            motivo['valor'] = item.valor;
            NdElectronica['datos']['motivos'].push(motivo);
        });
        
        NdElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString();// this.venta.cliente.correo;
        adicional['Direccion'] = this.venta.cliente.direccion.replace(/\//g,'-');

        let telefono = "0999999999";
        if( this.venta.cliente.telefono.toString().trim().length > 0 ){
            telefono = this.venta.cliente.telefono.toString();
        }
        if( this.venta.cliente.celular.toString().trim().length > 0 ){
            telefono = this.venta.cliente.celular.toString();
        }
        adicional['Telefono'] = telefono;

        NdElectronica['datos']['infoAdicional'].push(adicional);

        return NdElectronica;
    }

    setValueCobro(){
        this.cobro.fecha_cobro = moment(this.fecha_emision).format("YYYY-MM-DD");
        this.cobro.detalle = [];
        this.cobro.saldo = this.nota_debito.total;
        this.cobro.recibido = this.total_pago;
        this.cobro.cambio = this.cambio;        
        this.cobro.empresa_id = this.ss.getData("empresa_id");
        this.cobro.sucursal_id = this.ss.getData("sucursal_id");
        this.cobro.usuario_id = this.ss.getData("usuario_id");

        if( this.valorefectivo > 0 ){
            let cobro_detalle = new CobroDetalle();
            cobro_detalle.valor = this.valorefectivo;
            cobro_detalle.forma_pago_id = "1"; // EFECTIVO
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        }

        this.cheques.forEach(ch => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_cheque = ch.fecha;
            cobro_detalle.numero_cta = ch.cuenta;
            cobro_detalle.numero_cheque = ch.numero;
            cobro_detalle.banco_id = ch.banco_id;
            cobro_detalle.observacion = ch.observacion;

            cobro_detalle.valor = ch.valor;
            cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.tarjetas.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.debito_credito = tr.debito_credito;
            cobro_detalle.observacion = tr.observacion;
            cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
            cobro_detalle.valor = tr.valor;
            cobro_detalle.plazo = tr.plazo;
            cobro_detalle.tiempo = tr.tiempo;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.transferencias.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_transferencia = tr.fecha;
            cobro_detalle.numero_cta = tr.cuenta;
            cobro_detalle.numero_comprobante = tr.numero;
            cobro_detalle.banco_id = tr.banco_id;
            cobro_detalle.observacion = tr.observacion;

            cobro_detalle.valor = tr.valor;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });
    }

    onSubmit() {
        this.loading = true;
        this.setValueEntity();
        this.setValueCobro();

        if( this.Mod_FactElec ){
            if( this.venta.cliente.es_contribuyente ){
                if( this.venta.cliente.num_contribuyente.toString().trim().length === 0 ){
                    this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
                    return false;
                }
            }
            this.nota_debito.json_string = this.setNDElectronica();
        }
        this.notaDebitoService.save(this.nota_debito).subscribe(
            res => {
                this.loading = false;
                this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');

                this.nota_debito = new NotaDebito();
                this.notaDebitoDetalle = [];
                this.nota_detalle = new NotaDebitoDetalle();
                this.venta = new Venta();
                this.numero_documento = "";
                this.cambio = 0;
                this.total_pago = 0;
                this.cheques = [];
                this.tarjetas = [];
                this.valorefectivo = 0;
                this.transferencias = [];

                this.datosPagos.total_cheque = 0;
                this.datosPagos.total_tarjeta = 0;
                this.datosPagos.total_efectivo = 0;
                this.datosPagos.total_transferencia = 0;
            },
            err => {
                this.loading = false;
                this.msgSweet.showMessage('error-message',err);
            }
        );
    }

    setValueEntity(){
        this.nota_debito.is_secuencial_manual = this.is_numero_manual;
        if( this.is_numero_manual ) this.nota_debito.numero_documento = this.numero_documento;
        this.nota_debito.tipo = "V";
        this.nota_debito.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")
        this.nota_debito.caja_id = this.caja.id;
        this.nota_debito.documento_id = this.venta.id;
        this.nota_debito.cobros.push(this.cobro);
        this.venta.cliente.correo = this.correos.toString();

        this.notaDebitoDetalle.forEach(obj => {
                obj.subtotal = parseFloat(obj.valor.toString());
                if(obj.cod_iva == 0){
                    obj.iva = 0;
                    obj.porct_iva = 0;
                }
                else{
                    obj.iva = obj.subtotal * this.IVA;
                    obj.porct_iva = this.IVA_PARAM;
                }

                obj.total = obj.subtotal + obj.iva;
        });

        this.nota_debito.detalle = this.notaDebitoDetalle;

        this.nota_debito.usuario_id = this.ss.getData('usuario_id');
        this.nota_debito.empresa_id = this.ss.getData('empresa_id');
        this.nota_debito.sucursal_id = this.ss.getData('sucursal_id');
    }

    isValidForm(){
    if( this.is_numero_manual ){
            if( this.numero_documento.trim().length === 0 ){
                return false;
            }else{
                if( parseFloat(this.numero_documento.trim()) < 1 ){
                    return false;
                }
            }
        }
    if( !this.caja.id ){
        return false;
    }
    if( !this.nota_debito.tipo_comprobante_id ){
        return false;
    }
    if( !this.nota_debito.numero_documento ){

    }
    if( !this.venta.id ){
        return false;
    }
    if( this.notaDebitoDetalle.length < 1 ){
        return false;
    }
    if( this.nota_debito.tipo_pago === "CO" ){
        if( this.total_pago < this.nota_debito.total ){
            return false;
        }
    }
    if( this.Mod_FactElec ){
        if( this.venta.cliente.correo.trim().length === 0 ){
            return false;
        }
    }
    if( this.total_pago <= 0){
        return false;
    }
    if(this.fecha_emision < this.fecha_MesAnt){
        return false;
    }
    if( !this.correos.length ){
        return false;
    }

    return true;
    }

    onSearchRazon(){
        let Detalle = new NotaDebitoDetalle();
        Detalle.usuario_id = this.ss.getData('usuario_id');
		Detalle.empresa_id = this.ss.getData('empresa_id');
		Detalle.sucursal_id = this.ss.getData('sucursal_id');
        this.notaDebitoDetalle.push(Detalle);
    }

    calcularTotal(total){
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.nota_debito.total - this.nota_debito.abonado;

        this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        this.cambio = Math.round( this.cambio * 100) / 100;
    }

    onChangeEfectivo(total){
        this.valorefectivo = total;
    }

    onChangeFecha(event){
        if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/nota-debito-add/nota-debito-add.component.ts